// One clock for the whole HUD.
//
// The 31 Aug audit counted five hand-rolled relative-time formatters and
// three countdowns across the drawers, no two quite agreeing: "now" vs
// "just now", "5m" vs "5 min ago" vs "minutes ago", and a mentions
// timestamp that aged differently from the offering beside it. Every one
// of them was the same ladder re-typed at the call site, which is the
// habit the audit found under most of its findings.
//
// Two shapes, deliberately, because the surfaces genuinely want two
// registers: `agoShort` for tight chips and rows ("5m", "2h", "3d"),
// `ago` for prose ("5 min ago", "yesterday"). Anything fancier than
// these two is a new register, not a new function.

/** "now", "5m", "2h", "3d" — for chips and dense rows. */
export function agoShort(ts) {
  if (!ts) return ''
  const diff = Date.now() - ts
  if (diff < 60_000) return 'now'
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m`
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h`
  return `${Math.floor(diff / 86_400_000)}d`
}

/** "just now", "5 min ago", "3 hours ago", "yesterday" — for prose. */
export function ago(ts) {
  if (!ts) return ''
  const diff = Date.now() - ts
  if (diff < 60_000) return 'just now'
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} min ago`
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} hours ago`
  const days = Math.floor(diff / 86_400_000)
  return days === 1 ? 'yesterday' : `${days} days ago`
}

/** "gone", "12 minutes", "9 hours", "3 days" — time left on a thing. */
export function timeUntil(ms) {
  if (ms <= 0) return 'gone'
  const hours = ms / 3600e3
  if (hours < 1) return `${Math.max(1, Math.round(ms / 60000))} minutes`
  if (hours < 48) return `${Math.round(hours)} hours`
  return `${Math.round(hours / 24)} days`
}
